import React from "react";
import { Row, Col } from "react-flexbox-grid";
import Masonry from "react-masonry-css";
//Scss
import "./portfolio.scss";
//Assets
import Arrow from "../../assets/portfolio/arrow.svg";
import Preview1 from "../../assets/portfolio/project01/preview.webp";
import Preview2 from "../../assets/portfolio/project02/preview.webp";
import Preview3 from "../../assets/portfolio/project03/preview.webp";
import Preview4 from "../../assets/portfolio/project04/preview.webp";
import Preview5 from "../../assets/portfolio/project05/preview.webp";
import Preview6 from "../../assets/portfolio/project06/preview.webp";
//Components
import Button from "../ui-components/button/button";
import Title from "../ui-components/title/title";
import ProjectBox from "../ui-components/projectBox/projectBox";

class Services extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // SERVICES LIST
      services: [
        {
          id: "1",
          preview: Preview1,
          title: "Planeación Estratégica",
          tag: "planificacion",
        },
        {
          id: "2",
          preview: Preview2,
          title: "Diseño de Conceptos",
          tag: "planificacion",
        },
        {
          id: "3",
          preview: Preview3,
          title: "Coordinación y Logística",
          tag: "logistica",
        },
        {
          id: "4",
          preview: Preview4,
          title: "Gestión de Proveedores",
          tag: "logistica",
        },
        {
          id: "5",
          preview: Preview5,
          title: "Asesoría en Vestuario",
          tag: "asesoria-seguridad",
        },
        {
          id: "6",
          preview: Preview6,
          title: "Seguridad para Eventos",
          tag: "asesoria-seguridad",
        },
      ],
      // FILTERED LIST
      filterResult: null,
      pickedFilter: "all",
      filterMenuActive: false,
      pickedFilterDropdown: "NEWEST"
    };
  }

  // INITIAL LOAD
  componentDidMount() {
    this.filterGallery("all");
  }

  // FILTER FUNCTION
  filterGallery = (target) => {
    let servicesArr = [...this.state.services];
    let result;

    if (target !== "all") {
      result = servicesArr.filter((service) => service.tag === target);
    } else {
      result = servicesArr;
    }

    this.setState({ filterResult: result, pickedFilter: target, pickedFilterDropdown: "NEWEST" });
  };

  // FILTER DROP DOWN MENU HANDLER
  filterMenuHover = (event) => {
    this.setState({ filterMenuActive: event ? true : false });
  };

  filterDropDownHandler = (filter) => {
    this.setState({ pickedFilterDropdown: filter, filterMenuActive: false });

    let servicesArr = [...this.state.filterResult];
    let result;

    if (filter === "NEWEST") {
      result = servicesArr.sort((a, b) => (a.id > b.id ? 1 : -1));
    } else if (filter === "OLDEST") {
      result = servicesArr.sort((a, b) => (a.id > b.id ? 1 : -1)).reverse();
    }

    this.setState({ filterResult: result });
  };

  // RENDER
  render() {
    let servicesRender = null;
    if (this.state.filterResult) {
      servicesRender = this.state.filterResult.map((service) => (
        <ProjectBox preview={service.preview} key={service.id} title={service.title} tag={service.tag} />
      ));
    }

    // MASONRY GRID SETTINGS
    const servicesBreakpoints = {
      default: 3,
      1100: 3,
      700: 2,
      500: 1,
    };

    let filterDropDown = null;
    if (this.state.filterMenuActive) {
      filterDropDown = (
        <div className="portfolio__filter-menu shadow">
          <p className="font12" onClick={() => this.filterDropDownHandler("NEWEST")}>
            NEWEST
          </p>
          <p className="font12" onClick={() => this.filterDropDownHandler("OLDEST")}>
            OLDEST
          </p>
        </div>
      );
    }

    return (
      <div id="services">
        <div className="wrapper">
          <Title title="NUESTROS SERVICIOS" />
          <Row>
            <Col xs={12} sm={12} md={8} lg={9}>
              <div className="portfolio__nav">
                <ul>
                  <li className={this.state.pickedFilter === "all" ? "portfolio__nav-active font12" : "font12"} onClick={() => this.filterGallery("all")}>
                    TODOS
                  </li>
                  <li
                    className={this.state.pickedFilter === "planificacion" ? "portfolio__nav-active font12" : "font12"}
                    onClick={() => this.filterGallery("planificacion")}
                  >
                    PLANIFICACIÓN
                  </li>
                  <li
                    className={this.state.pickedFilter === "logistica" ? "portfolio__nav-active font12" : "font12"}
                    onClick={() => this.filterGallery("logistica")}
                  >
                    LOGÍSTICA
                  </li>
                  <li
                    className={this.state.pickedFilter === "asesoria-seguridad" ? "portfolio__nav-active font12" : "font12"}
                    onClick={() => this.filterGallery("asesoria-seguridad")}
                  >
                    ASESORÍA Y SEGURIDAD
                  </li>
                </ul>
              </div>
            </Col>
            <Col xs={12} sm={12} md={4} lg={3}>
              <div className="portfolio__filter" onMouseEnter={() => this.filterMenuHover(true)} onMouseLeave={() => this.filterMenuHover(false)}>
                <p className="font12">{this.state.pickedFilterDropdown} FIRST</p>
                <img src={Arrow} alt="arrow" />
                {filterDropDown}
              </div>
            </Col>
          </Row>
          <Masonry breakpointCols={servicesBreakpoints} className="my-masonry-grid" columnClassName="mint__gallery">
            {servicesRender}
          </Masonry>
          <Row className="flex-center padding40">
            <Button label="¿NECESITAS MÁS INFORMACIÓN?" target={"contact"} />
          </Row>
        </div>
      </div>
    );
  }
}

export default Services;
